/**
 * @file Bare `<input type="range">` styled to match the dark HUD palette.
 * Deliberately dumb — drag-vs-snapshot arbitration (see TimeOfDay) lives in
 * the caller, not here.
 */
export default function Slider({
  value,
  min = 0,
  max = 1,
  step = 0.01,
  onChange,
  onDragStart,
  onDragEnd,
  className = '',
}) {
  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={onChange}
      onMouseDown={onDragStart}
      onMouseUp={onDragEnd}
      onTouchStart={onDragStart}
      onTouchEnd={onDragEnd}
      className={
        'h-1.5 w-full cursor-pointer appearance-none rounded-full bg-[#1a1a24] accent-[#5a6ff0] ' +
        '[&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:appearance-none ' +
        '[&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[#5a6ff0] ' +
        className
      }
    />
  );
}
